import React, { useContext, useEffect, useState } from "react";
import { Modal, Card, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

const EditOffCanvance = (props) => {
  const id = props.show;
  const { getData, postData, Select2Data } = useContext(Context);

  const [products, setProducts] = useState([]);
  const [discountType, setDiscountType] = useState("");
  const [showModal, setShowModal] = useState({ code: 0, message: "" });

  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const getProducts = async () => {
    const res = await getData("/all-products");
    if (res?.success) {
      setProducts(await Select2Data(res.data, "product_id"));
    }
  };

  const getSingleData = async () => {
    const res = await getData(`/offerproduct/${id}`);
    if (res?.success) {
      const data = res.data;

      // Set form values
      // setValue("product_id", {
      //   value: data.product_id,
      //   label: data.product?.name,
      // });
      setValue("product_id", data.product_id);
      setValue("discount", data.discount);
      setValue("message", data.message || "");
      setDiscountType(data.discount_type);
    }
  };

  useEffect(() => {
    if (id && props.show) {
      getProducts();
      getSingleData();
    }
  }, [id, props.show]);

  const onSubmit = async (data) => {
    const fd = new FormData();
    fd.append("product_id", data.product_id.value);
    fd.append("discount_type", discountType);
    fd.append("discount", data.discount);
    fd.append("message", data.message || "");

    const res = await postData(`/offerproduct/${id}`, fd);
    setShowModal({ code: res.code, message: res.message });

    if (res.success) {
      setTimeout(() => props.handleClose(), 1000);
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={props.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Offer Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card className="shadow">
            <Card.Body>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Product</Form.Label>
                      <Controller
                        name="product_id"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={products}
                            placeholder="Select Product"
                            isDisabled
                          />
                        )}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Discount Type</Form.Label>
                      <Form.Select
                        value={discountType}
                        onChange={(e) => setDiscountType(e.target.value)}
                      >
                        <option value="percentage">Percentage (%)</option>
                        <option value="fixedamount">Fixed Amount</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {discountType === "percentage"
                          ? "Discount (%)"
                          : "Discount Amount"}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        {...register("discount", {
                          required: "Discount is required",
                        })}
                      />
                      {errors.discount && (
                        <small className="text-danger">
                          {errors.discount.message}
                        </small>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Message (Optional)</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        {...register("message")}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col className="text-center">
                    <CancelButton
                      name="Cancel"
                      handleClose={props.handleClose}
                    />
                    <SaveButton
                      name="Update"
                      handleSubmit={handleSubmit(onSubmit)}
                    />
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={!!showModal.code}
      />
    </>
  );
};

export default EditOffCanvance;
